module.exports = __webpack_public_path__ + "static/media/1.d9ffe9f0.JPG";